module.exports = __webpack_public_path__ + "media/images/Sort-6b8adf8d5eed108520a3230481f99ade.svg";